<template>
  <div class="add-prdtoption">
    <div
      class="modal-pagecnt"
      :class="{ open_modal: openAddProductOptionModal }"
    >
      <header class="modalpage-header">
        <span
          class="icon-Btn go-back"
          @click="$emit('closeAddProductOptionModal')"
        >
          <ArrowLeftBackIcon />
        </span>
        <h1>Back</h1>
      </header>

      <div class="nodata-texbox" v-if="!isProductListLength">
        आपने अभी तक कोई नहीं प्रोडक्ट को ऐड नहीं किया है। सेल को और बढ़ाने के लिए
        प्रोडक्ट को ऐड करे।
      </div>

      <div class="modal-midcnt">
        <div class="prdt-type">
          <div class="product-tab" @click="productsearch()">
            <div class="prdt-icon">
              <ProductSearchIcon />
            </div>
            <div class="prdt-info">
              <h2>प्रोडक्ट सर्च करे</h2>
              <p>प्रोडक्ट का नाम सर्च करें और सर्च रिजल्ट्स मैं देखके अपना प्रोडक्ट कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">सर्च करे </span>
              </div>
            </div>
          </div>
          <div class="product-tab" @click="productBarScan()">
            <div class="prdt-icon">
              <ProductBarCodeIcon />
            </div>
            <div class="prdt-info">
              <h2>बारकोड स्कैन करे</h2>
              <p>आपके पास मौजूदा प्रोडक्ट का बार कोड स्कैन करें। फिर स्कैन्ड प्रोडक्ट्स की लिस्ट से प्रोडक्ट को कैटेलॉग मैं ऐड करें।</p>
              <div class="btn-block">
                <span class="button">स्कैन करे </span>
              </div>
            </div>
          </div>
          <div class="product-tab" @click="addProduct()">      
            <div class="prdt-icon">
              <AddProductIcon />
            </div>
            <div class="prdt-info">
              <h2>नया प्रोडक्ट जोड़ें</h2>
              <p>फॉर्म मैं अपने प्रोडक्ट्स के सभी डिटेल्स बहोत ध्यान से भरें जैसे नाम, प्रोडक्ट के बारे मैं, प्राइस, आदि और सबमिट करके अपने प्रोडक्ट को कैटेलॉग मैं जोड़ें।</p>
              <div class="btn-block">
                <span class="button">प्रोडक्ट जोड़ें </span>
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '../../assets/css/add-product-option.scss';
import ArrowLeftBackIcon from '@/components/Icons/ArrowLeftBackIcon';
import ProductSearchIcon from '@/components/Icons/ProductSearchIcon';
import ProductBarCodeIcon from '@/components/Icons/ProductBarCodeIcon';
import AddProductIcon from '@/components/Icons/AddProductIcon';

export default {
  name: 'AddProductOptionModal',
  props: {
    openAddProductOptionModal: Boolean,
    isProductListLength: Boolean
  },
  data() {
    return {};
  },
  components: {
    ArrowLeftBackIcon,
    ProductSearchIcon,
    ProductBarCodeIcon,
    AddProductIcon,
  },
  watch: {},
  methods: {
    productsearch(){
      let pathvalue;
      if(this.$route.query.CLOUDSHOP){
        pathvalue = `/product-search?shopid=${this.$route.query.shopid}&CLOUDSHOP=YES`
      }else{
        pathvalue = `/product-search?shopid=${this.$route.query.shopid}`
      }
      this.$router.push(pathvalue)
    },
    productBarScan(){
      let pathvalue;
      if(this.$route.query.CLOUDSHOP){
        pathvalue = `/product-bar-scan?shopid=${this.$route.query.shopid}&CLOUDSHOP=YES`
      }else{
        pathvalue = `/product-bar-scan?shopid=${this.$route.query.shopid}`
      }
      this.$router.push(pathvalue)
    },
    addProduct(){
      let pathvalue;
      if(this.$route.query.CLOUDSHOP){
        pathvalue = `/add-product?shopid=${this.$route.query.shopid}&CLOUDSHOP=YES`
      }else{
        pathvalue = `/add-product?shopid=${this.$route.query.shopid}`
      }
      this.$router.push(pathvalue)
    }
  },
  mounted() {},
};
</script>
